module.exports = __webpack_public_path__ + "static/img/more.61667d5f.svg";